import { type MouseEvent, memo, useCallback } from 'react';

import { ArchiveRestoreIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

export type WorkspaceAgentPanelMyTasksRowUnarchiveButtonProps = {
  isDisabled: boolean;
  onUnarchive: () => void;
  sessionTitle: string;
};

export const WorkspaceAgentPanelMyTasksRowUnarchiveButton = memo(
  ({ isDisabled, onUnarchive, sessionTitle }: WorkspaceAgentPanelMyTasksRowUnarchiveButtonProps) => {
    const unarchiveLabel = `Unarchive ${sessionTitle}`;

    const handleClick = useCallback(
      (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onUnarchive();
      },
      [onUnarchive],
    );

    return (
      <div className="pointer-events-none absolute top-2 right-2 opacity-0 transition-opacity group-focus-within:pointer-events-auto group-focus-within:opacity-100 group-hover:pointer-events-auto group-hover:opacity-100">
        <Tooltip label={unarchiveLabel} side="bottom" sideOffset={4}>
          <IconButton
            adsIcon
            appearance="ghost"
            color="gray"
            data-testid="WORKSPACE_AGENT_PANEL_MY_TASKS_ROW_UNARCHIVE_TASK"
            disabled={isDisabled}
            label={unarchiveLabel}
            onClick={handleClick}
            size="small"
            type="button"
            icon={ArchiveRestoreIcon}
          />
        </Tooltip>
      </div>
    );
  },
);

WorkspaceAgentPanelMyTasksRowUnarchiveButton.displayName = 'WorkspaceAgentPanelMyTasksRowUnarchiveButton';
